import React, { useEffect, useRef } from "react";
import axios from "axios";

const API = axios.create({
  baseURL: "http://localhost:5000/api",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

function loadPayPalScript(clientId) {
  return new Promise((resolve) => {
    const existing = document.getElementById("paypal-sdk");
    if (existing) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.id = "paypal-sdk";
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&vault=true&intent=subscription`;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export default function PayPalSubscriptionButton({
  clientId,
  planId,
  onActivated,
}) {
  const buttonRef = useRef(null);
  const renderedRef = useRef(false);
  const onActivatedRef = useRef(onActivated);

  useEffect(() => {
    onActivatedRef.current = onActivated;
  }, [onActivated]);

  useEffect(() => {
    let mounted = true;

    async function renderButton() {
      if (!clientId || !planId || planId === "P-XXXXXXXXXXXX") return;
      if (renderedRef.current) return;

      const loaded = await loadPayPalScript(clientId);
      if (!loaded || !window.paypal || !buttonRef.current || !mounted) return;

      renderedRef.current = true;

      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            layout: "vertical",
            label: "subscribe",
          },
          createSubscription(data, actions) {
            return actions.subscription.create({
              plan_id: planId,
            });
          },
          async onApprove(data) {
            try {
              const res = await API.post("/subscription/paypal/verify", {
                plan: "starter",
                subscriptionId: data.subscriptionID,
              });

              alert(res?.data?.message || "PayPal subscription activated");
              if (onActivatedRef.current) onActivatedRef.current();
            } catch (error) {
              console.error(error);
              alert(
                error?.response?.data?.message || "PayPal verification failed"
              );
            }
          },
          onError(err) {
            console.error(err);
            alert("PayPal checkout failed");
          },
        })
        .render(buttonRef.current);
    }

    renderButton();

    return () => {
      mounted = false;
    };
  }, [clientId, planId]);

  return <div ref={buttonRef}></div>;
}